import { Component, Input, OnInit } from '@angular/core';
import { CreditsafesService } from '../creditsafe.service';

@Component({
  selector: 'app-creditsafe-social-balance-sheets',
  templateUrl: './creditsafe-social-balance-sheets.component.html',
  styleUrls: ['./creditsafe-social-balance-sheets.component.scss']
})
export class CreditsafeSocialBalanceSheetsComponent implements OnInit {
  @Input() element: any;

  public items: any[] = [];
  public dataList: any[] = []

  constructor(public creditsafesService: CreditsafesService) { }

  ngOnInit(): void {
    this.items = this.element.Report?.AdditionalInformation.SocialBalanceSheets ?? [];
    this.loadDataList(this.items[0], undefined);
    this.dataList = this.dataList.filter((s: string) => !['Currency', 'ReportingYearEnd'].includes(s));
  }

  public loadDataList(obj: any, parent: string | undefined) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.dataList.push(key);
          this.loadDataList(obj[key], key);
        } else {
          this.dataList.push(parent == undefined ? key : parent + '.' + key);
        }
      }
    }
  }

}
